import { useEffect, useState } from 'react';

import {
  exportToLocalStorage,
  importFromLocalStorage,
} from '$/utils/localstorage';

const useStateWithLocalStorage = <T>(
  name: string,
  initialValue: any = undefined,
  parse: any = (a) => a
): ReturnType<typeof useState<T>> => {
  const [state, setState] = useState<T | null>(
    parse(importFromLocalStorage(name, initialValue))
  );

  useEffect(() => {
    exportToLocalStorage(name, state);
  }, [state]);

  return [state, setState];
};

export default useStateWithLocalStorage;
